import { useSession } from '../store/session';
import type { Aspect } from '../router/types';

const ASPECTS: Aspect[] = ['1:1', '3:4', '4:3', '9:16', '16:9', '21:9'];

export default function AspectRatio() {
  const aspect = useSession(s => s.aspect);
  const setAspect = useSession(s => s.setAspect);
  return (
    <select className="chip" value={aspect} onChange={e => setAspect(e.target.value as Aspect)}>
      {ASPECTS.map(a => <option key={a} value={a}>{a}</option>)}
    </select>
  );
}
